import { Button, ButtonGroup } from '@mui/material'
import { FC } from 'react'

import ChevronLeftIcon from '../../../../assets/icons/ChevronLeft.svg'
import ChevronRightIcon from '../../../../assets/icons/ChevronRight.svg'

type Props = {
    handleNext: VoidFunction
    handlePrev: VoidFunction
    handleToday: VoidFunction
}

export const StepperCalendar: FC<Props> = ({ handleNext, handlePrev, handleToday }) => {
    return (
        <ButtonGroup
            variant="outlined"
            sx={{
                minHeight: '32px',
                boxShadow: 'none',
                backgroundColor: 'transparent',
                color: '#1B1C1D',
                borderColor: '#E5E5E7',
                '& > button': {
                    minHeight: '32px',
                    height: '32px',
                    minWidth: '32px',
                    p: '6px 11px',
                    color: '#1B1C1D !important',
                    borderColor: '#E5E5E7',
                    ':hover': {
                        backgroundColor: '#F6F6F6',
                    },
                },
                '& > button:first-of-type, > button:last-of-type': {
                    p: '6px',
                    minHeight: '32px',
                    minWidth: '32px',
                },
            }}>
            <Button onClick={handlePrev}>
                <ChevronLeftIcon />
            </Button>
            <Button onClick={handleToday}>Сегодня</Button>
            <Button onClick={handleNext}>
                <ChevronRightIcon />
            </Button>
        </ButtonGroup>
    )
}
